import Vue from 'vue'
import * as VueAos from 'vue-aos';

Vue.use(VueAos);